import React from 'react';

export interface KhelDropLogoProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string;
  color?: string;
  className?: string;
}

export default function KhelDropLogo({
  size = 28,
  color = '#7C3AED',
  className = '',
  style = {},
  ...props
}: KhelDropLogoProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      width={size}
      height={size}
      className={className}
      style={{ display: 'inline-block', verticalAlign: 'middle', flexShrink: 0, ...style }}
      {...props}
    >
      {/* Outer Dial */}
      <circle cx="50" cy="50" r="40" stroke={color} strokeWidth="8" fill="none" />

      {/* Minute Hand: Hockey Stick (Shortened to leave a gap) */}
      <path
        fill={color}
        d="M 47.5 50 V 28 C 47.5 20 51 18 55 18 H 60 A 2.5 2.5 0 0 1 60 23 H 55 C 53.5 23 52.5 24 52.5 28 V 50 Z"
      />

      {/* Hour Hand: Cricket Bat (Shortened to leave a gap) */}
      <g transform="rotate(135 50 50)">
        <path
          fill={color}
          d="M 48 50 V 34 L 44 30 V 20 Q 50 15 56 20 V 30 L 52 34 V 50 Z"
        />
      </g>

      {/* Center Joint: Football */}
      <circle cx="50" cy="50" r="9" fill="#ffffff" stroke={color} strokeWidth="2" />

      {/* Football inner pentagon */}
      <polygon points="50,46 53.8,48.8 52.3,53.2 47.7,53.2 46.2,48.8" fill={color} />

      {/* Football panel lines radiating outwards */}
      <path
        stroke={color}
        d="M50 46 L50 41 M53.8 48.8 L58.5 47.2 M52.3 53.2 L55.3 57.3 M47.7 53.2 L44.7 57.3 M46.2 48.8 L41.5 47.2"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
